<script setup lang="ts">
import { Alert, AlertDescription, AlertTitle } from './alert';
</script>

<template>
  <Alert variant="destructive">
    <AlertTitle>No Access</AlertTitle>
    <AlertDescription>
      You don't have access to any facilities. Please contact an admin and ask them to add permissions to your account.
    </AlertDescription>
  </Alert>
</template>
